import {createProduktlyScript} from './createProduktlyScript';
import {isProduktlyEnabled} from './isProduktlyEnabled';

export function ProduktlyHead() {
  if (!isProduktlyEnabled()) {
    return null;
  }

  const clientToken =
    (import.meta.env.VITE_PRODUKTLY_CLIENT_TOKEN as string | undefined)
      ?.trim() ?? '';

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: createProduktlyScript(clientToken),
      }}
    />
  );
}
